var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-table_svg__clip0_816_14517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.412 2.388c-.36 0-.65.317-.65.708v14.029c0 .846.63 1.532 1.41 1.532h16.702c.779 0 1.41-.686 1.41-1.532V3.096c0-.391-.291-.708-.65-.708H1.411zm.65 14.737v-3.42h4.014v3.537H2.17c-.06 0-.108-.052-.108-.117zm5.315.117h11.497c.06 0 .108-.052.108-.117v-3.42H7.377v3.537zm0-4.951h11.605V8.283H7.377v4.008zM6.076 8.283H2.063v4.008h4.013V8.283z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-table_svg__clip0_816_14517"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.761 .761)",
    d: "M0 0h19.523v19.523H0z"
  })))));
}
export default SvgSvgTable;